import { getAppointments, type AppointmentData } from "@/http/classesApi";
import { getAppointmentsQueryKey } from "@/utils/queryKeys";
import { useQuery } from "@tanstack/react-query";
import { getCookie } from "@/utils/cookies";

type UseGetAppointmentsQueryParams = {
  activeOnly?: boolean;
};

export const useGetAppointmentsQuery = (params?: UseGetAppointmentsQueryParams) => {
  const { activeOnly = true } = params || {};
  const userToken = getCookie("user_token");

  return useQuery<AppointmentData[]>({
    // Include activeOnly and userToken in cache key to prevent cache collisions
    queryKey: [...getAppointmentsQueryKey(), { activeOnly, userToken }],
    queryFn: async () => {
      const response = await getAppointments(userToken, activeOnly);
      return response.data.data;
    },
    enabled: !!userToken,
  });
};
